import { http } from "@/utils/http"

export type UserResult = {
  code: number
  time: number
  msg: string
  data: {
    /** `token` */
    token: string
    /** 用户信息 */
    info: {
      id: number
      account: string
      name: string
      orgId: number
      orgAdmin: number
      orgName: string
      maxkeyId: string
    }
  }
}

export type RefreshTokenResult = {
  success: boolean
  data: {
    /** `token` */
    accessToken: string
    /** 用于调用刷新`accessToken`的接口时所需的`token` */
    refreshToken: string
    /** `accessToken`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: Date
  }
}

/** 登录 */
export const getLogin = (data: { account: string; password: string }) => {
  return http.request<UserResult>("post", "/api/v1/console/auth/login", { data })
}

/** 刷新`token` */
export const refreshTokenApi = (data?: object) => {
  return http.request<RefreshTokenResult>("post", "/refresh-token", { data })
}
